import axios from 'axios'
import {ALTERAR_AGENCIAS} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function alterarRota (agencia) {
  const url = `${URL}/agencia/alterar`;
  return dispatch => axios.post(url, agencia, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ALTERAR_AGENCIAS,
        payload: response
      })
  );
}
